/**
 * gmp variant-filter v3（2026-09-06，徐总拍板：级联过滤模型）
 *
 * 模型：Style（第 1 维）永远全量显示；选了 Style 后，Color 只显示该 Style
 * 对应的颜色组合；Size 只显示当前 Style+Color 下存在的尺寸。
 * 即「前置维度决定后置维度显示什么」——经典级联选择器。
 * 已选值因切换而被过滤掉时，自动切到该组第一个可见值（与源站一致）。
 *
 * 版本史：
 *   v1 隐藏模型（双向过滤：选了 Color 会把 Style 也藏掉）→ 徐总反馈
 *      「风格变体显示不全」（h541v2 默认选 S Black 后 Style 只剩 1 个值）。
 *   v2/v2.1 源站全量显示 + 冲突自动协调 → 徐总拍板改级联过滤（本版）。
 *
 * 金猴主题机制（FoxTheme/Hyper，实测锁定）：
 *   点 radio → change（element capture）→ 主题读其 variant-selects 内所有
 *   fieldset 的 checked 组合 → fetch section API（option_values）→ 服务器端
 *   渲染 HTML → 整体替换 variant-selects DOM（checked/价格/图/URL 一起更新）。
 *   服务器渲染的 HTML 永远带全量选项值 + 给无组合值加 .disabled 类，因此：
 *   ① 本脚本在 document capture（先于主题）把「与前置维度不兼容的后置选中值」
 *      预切换成第一个兼容值，让主题 fetch 的就是合法组合；
 *   ② DOM 被替换后必须重新应用级联过滤（MutationObserver）；
 *   ③ .disabled 的三层视觉（文本/伪元素对角线/灰化）用 CSS 全覆盖（画斜杠=该机制）。
 *   页面有主模板+quick-view 两套 radio（各在独立 form，name 完全相同含换行），
 *   必须按 closest('variant-selects') 隔离，两套分别处理。
 *
 * 数据源：/products/{handle}.js（与抓取引擎同源，option1/2/3 + options）。
 * 注意：本文件会被 Shopify 压缩——严禁正则字面量（压缩器会损坏）；一律用字符串运算。
 */
(function () {
  if (window.location.pathname.indexOf("/products/") !== 0) return;
  if (window.__gmpVariantFilterLoaded) return;
  window.__gmpVariantFilterLoaded = true;

  // ① 清除主题「画斜杠」三层视觉（component-product-variant-picker.css 实测锁定）：
  //   label > .label-unavailable 文本 / button 型 label:before 对角线+灰字 /
  //   color-swatch 型 .swatch-color 半透明+对角线
  // ② 级联过滤隐藏类（本脚本专用）
  var style = document.createElement("style");
  style.textContent =
    ".gmp-option-hidden{display:none!important}" +
    ".label-unavailable{display:none!important}" +
    ".product-form__input--button input[type=radio]:is(.disabled,.visually-disabled)+label," +
    ".product-form__input--button input[type=radio]:disabled+label{" +
    "border-color:rgb(var(--color-foreground))!important;" +
    "color:rgb(var(--color-foreground))!important;" +
    "opacity:1!important}" +
    ".product-form__input--button input[type=radio]:is(.disabled,.visually-disabled)+label:before," +
    ".product-form__input--button input[type=radio]:disabled+label:before," +
    ".product-form__input--button input[type=radio]:is(.disabled,.visually-disabled):checked+label:before," +
    ".product-form__input--button input[type=radio]:disabled:checked+label:before{" +
    "content:none!important;display:none!important;background:none!important}" +
    ".product-form__input--color input[type=radio]:is(.disabled,.visually-disabled)+label," +
    ".product-form__input--swatch input[type=radio]:is(.disabled,.visually-disabled)+label," +
    ".product-form__input--color input[type=radio]:is(.disabled,.visually-disabled)+label .swatch-color," +
    ".product-form__input--swatch input[type=radio]:is(.disabled,.visually-disabled)+label .swatch-color{" +
    "opacity:1!important}" +
    ".product-form__input--color input[type=radio]:is(.disabled,.visually-disabled)+label .swatch-color:before," +
    ".product-form__input--swatch input[type=radio]:is(.disabled,.visually-disabled)+label .swatch-color:before{" +
    "content:none!important;display:none!important;background:none!important}";
  document.head.appendChild(style);

  var PRODUCT = null;
  var HIDDEN_CLASS = "gmp-option-hidden";

  function optionPosition(input) {
    // name 形如 "Style-1"（可能带换行/空格）→ 取最后一个 "-" 后的数字
    var name = input.getAttribute("name") || "";
    var lastDash = name.lastIndexOf("-");
    if (lastDash < 0) return 0;
    var suffix = name.slice(lastDash + 1).trim();
    var num = parseInt(suffix, 10);
    return isNaN(num) ? 0 : num;
  }

  function radiosOfPosition(p, scope) {
    // scope = variant-selects 组件（主模板与 quick-view 两套隔离）
    var root = scope || document;
    var all = Array.prototype.slice.call(root.querySelectorAll("input[type='radio']"));
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (optionPosition(all[i]) === p) out.push(all[i]);
    }
    return out;
  }

  function variantValue(v, pos) {
    return pos === 1 ? v.option1 : pos === 2 ? v.option2 : v.option3;
  }

  function currentCombo(positions, scope) {
    var combo = {};
    for (var p = 1; p <= positions; p++) {
      var radios = radiosOfPosition(p, scope);
      var found = "";
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          found = radios[i].value;
          break;
        }
      }
      combo[p] = found;
    }
    return combo;
  }

  // 级联可见性：position p 的值 value 可见 ⇔ 存在一个变体满足
  // 「该维度=value 且所有前置维度(1..p-1)=当前选中值」。
  // 后置维度不参与约束（前置决定后置）。
  function visibleAt(p, value, selections) {
    var variants = PRODUCT.variants;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((variantValue(v, p) || "") !== value) continue;
      var ok = true;
      for (var q = 1; q < p; q++) {
        if ((variantValue(v, q) || "") !== (selections[q] || "")) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  function labelOf(input) {
    return document.querySelector('label[for="' + input.id + '"]') || input.closest("label");
  }

  function setHidden(input, hidden) {
    var label = labelOf(input);
    if (hidden) {
      input.classList.add(HIDDEN_CLASS);
      if (label) label.classList.add(HIDDEN_CLASS);
    } else {
      input.classList.remove(HIDDEN_CLASS);
      if (label) label.classList.remove(HIDDEN_CLASS);
    }
  }

  function isHidden(input) {
    return input.classList.contains(HIDDEN_CLASS);
  }

  function firstVisibleRadio(p, scope, selections) {
    var radios = radiosOfPosition(p, scope);
    for (var i = 0; i < radios.length; i++) {
      if (!isHidden(radios[i]) && visibleAt(p, radios[i].value, selections)) return radios[i];
    }
    return null;
  }

  function setCheckedOnly(pos, value, scope) {
    // 只改 checked 不触发事件；主题随后的 capture handler 会读到新组合
    var radios = radiosOfPosition(pos, scope);
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        radios[i].checked = true;
        return;
      }
    }
  }

  // 级联过滤主流程：隐藏不满足前置条件的值；已选值被隐藏则自动切第一个可见值
  function applyFilter(scope, positions) {
    var selections = currentCombo(positions, scope);

    // 1) 隐藏
    for (var p = 1; p <= positions; p++) {
      var radios = radiosOfPosition(p, scope);
      for (var i = 0; i < radios.length; i++) {
        var visible = visibleAt(p, radios[i].value, selections);
        setHidden(radios[i], !visible);
      }
    }

    // 2) 已选值被隐藏 → 自动切第一个可见值并触发 change（与源站一致）
    for (var p2 = 1; p2 <= positions; p2++) {
      var group = radiosOfPosition(p2, scope);
      for (var j = 0; j < group.length; j++) {
        var radio = group[j];
        if (!radio.checked || !isHidden(radio)) continue;
        var first = firstVisibleRadio(p2, scope, selections);
        if (first && first !== radio) {
          radio.checked = false;
          first.checked = true;
          first.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  }

  function onCapture(e) {
    var t = e.target;
    if (!t || t.type !== "radio") return;
    var pos = optionPosition(t);
    if (pos < 1) return;
    if (!PRODUCT) return; // 数据未就绪：放行给主题原生处理
    var positions = PRODUCT.options ? PRODUCT.options.length : 3;
    if (pos > positions) return;

    var scope = t.closest ? t.closest("variant-selects") : null;
    var selections = currentCombo(positions, scope);

    // 预切换：后置维度（pos+1..positions）当前选中值与前置维度不兼容时，
    // 切到第一个兼容值（只改 checked 不触发事件），让主题 fetch 合法组合
    for (var q = pos + 1; q <= positions; q++) {
      if (!selections[q]) continue;
      if (visibleAt(q, selections[q], selections)) continue;
      var first = firstVisibleRadio(q, scope, selections);
      if (first) {
        setCheckedOnly(q, first.value, scope);
        selections[q] = first.value;
      }
    }
    // 放行：主题读协调后的 checked 组合，fetch 后整体更新 DOM
  }

  function applyAllScopes() {
    if (!PRODUCT) return;
    var positions = PRODUCT.options ? PRODUCT.options.length : 3;
    var scopes = Array.prototype.slice.call(document.querySelectorAll("variant-selects"));
    for (var i = 0; i < scopes.length; i++) {
      applyFilter(scopes[i], positions);
    }
  }

  function load(attempt) {
    fetch(window.location.pathname + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        PRODUCT = product;
        document.addEventListener("change", onCapture, true);
        applyAllScopes();
        // 主题 fetch 后整体替换 variant-selects DOM → 重新应用过滤
        var observer = new MutationObserver(function () {
          var positions2 = PRODUCT.options ? PRODUCT.options.length : 3;
          if (radiosOfPosition(1, document).length > 0) {
            applyAllScopes();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {
        if (attempt < 3) {
          window.setTimeout(function () {
            load(attempt + 1);
          }, 1500);
        }
      });
  }

  load(1);
})();
